import React from "react";
import { motion } from "framer-motion";

/**
 * A decorative animated 3D scene of floating geometric shapes and soft color blobs.
 * Purely decorative — placed behind content.
 */
export default function FloatingScene({ dense = false, className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {/* Soft color blobs */}
      <motion.div
        className="blob blob-green"
        style={{ width: dense ? 380 : 520, height: dense ? 380 : 520, top: "-8%", right: "-6%" }}
        animate={{ x: [0, 20, -10, 0], y: [0, -14, 10, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="blob blob-yellow"
        style={{ width: dense ? 300 : 460, height: dense ? 300 : 460, bottom: "-14%", left: "-5%" }}
        animate={{ x: [0, -18, 10, 0], y: [0, 12, -8, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="blob blob-red"
        style={{ width: 260, height: 260, top: "40%", left: "58%", opacity: 0.35 }}
        animate={{ x: [0, 22, -12, 0], y: [0, -18, 14, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Geometric shapes */}
      <motion.div
        className="shape shape-a"
        style={{
          width: 96, height: 96, top: "18%", left: "8%",
          background: "linear-gradient(135deg, hsl(var(--shape-green)), hsl(142, 71%, 65%))",
          transform: "rotate(15deg)",
          boxShadow: "0 20px 40px -14px hsla(142, 71%, 30%, 0.4)",
        }}
      />
      <motion.div
        className="shape shape-b"
        style={{
          width: 72, height: 72, top: "58%", left: "22%",
          background: "linear-gradient(135deg, hsl(var(--shape-yellow)), hsl(48, 96%, 75%))",
          borderRadius: 999,
          boxShadow: "0 20px 40px -14px hsla(48, 96%, 40%, 0.45)",
        }}
      />
      <motion.div
        className="shape shape-c"
        style={{
          width: 60, height: 60, top: "28%", right: "18%",
          background: "linear-gradient(135deg, hsl(var(--shape-red)), hsl(0, 74%, 78%))",
          borderRadius: 14,
          boxShadow: "0 20px 40px -14px hsla(0, 74%, 40%, 0.45)",
        }}
      />
      <motion.div
        className="shape spin-3d"
        style={{
          width: 110, height: 110, bottom: "10%", right: "10%",
          background: "conic-gradient(from 0deg, hsl(142, 71%, 45%), hsl(48, 96%, 55%), hsl(0, 74%, 55%), hsl(142, 71%, 45%))",
          borderRadius: 24,
          opacity: 0.35,
          filter: "blur(0.5px)",
        }}
      />
    </div>
  );
}
